import { authApiCall } from '../auth/saga';

export const getLatestRedemptions = params =>
  authApiCall({
    url: '/coupons/admin/redemptions/',
    method: 'get',
    params,
  });